import { render } from "./TabEvidencias.vue?vue&type=template&id=b43b27fe&scoped=true"
import script from "./TabEvidencias.vue?vue&type=script&lang=js"
export * from "./TabEvidencias.vue?vue&type=script&lang=js"

import "./TabEvidencias.vue?vue&type=style&index=0&id=b43b27fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b43b27fe"]])

export default __exports__